import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';

export const useGetUserProfessionalStatus = () => {
  const userCertificateService = useServices().userCertificateService;
  return useQuery({
    queryKey: ['userProfessionalStatus'],
    queryFn: () => userCertificateService.checkAvailableCertificates(),
    refetchOnWindowFocus: false,
  });
};
